/**
 * Local platform-branding assets, served from the frontend's own public/
 * directory (not the @stw/types CDN constants, which are also written to
 * the database as persisted defaults and can't simply be repointed here).
 */

/** The platform's name (client, 2026-10-13). A brand name, so it stays in
 * English in every locale. */
export const PLATFORM_NAME = 'OSCE-AI Platform: AI Patient Connect';

/** Generated illustrations (docs/illustrations.md), 1200×896 JPEGs hosted
 * with the other assets. Landing page hero, the Resources "Why practise"
 * banner, then one per practice-type card. */
const ASSETS = 'https://storage.googleapis.com/cuhk-metaverse/public/assets';
export const HERO_IMAGE_URL = `${ASSETS}/OSCE_hero_image.jpg`;
export const RESOURCES_WHY_IMAGE_URL = `${ASSETS}/OSCE_resources_why.jpg`;
export const PRACTICE_MODE_IMAGE_URLS = {
  general: `${ASSETS}/OSCE_landing_1.jpg`,
  osce: `${ASSETS}/OSCE_landing_2.jpg`,
  comm: `${ASSETS}/OSCE_landing_3.jpg`,
} as const;

/** Header logo — CUHK's full-colour horizontal lockup (crest + 香港中文大學/
 * CUHK wordmark baked into one image), same asset cuhk-osce-simulation uses
 * in its header. Hosted externally, not a local file — matches how that
 * repo and the footer logos below are all served. */
export const PLATFORM_LOGO_URL =
  'https://storage.googleapis.com/cuhk-metaverse/public/assets/cuhk_full_color.png';

/** Footer partner/affiliate logos, in display order — ported from
 * cuhk-osce-simulation's footer (src/app/page.tsx). Dimensions match that
 * repo's fixed pixel sizing (not responsive there either). */
export const FOOTER_LOGOS = [
  {
    url: 'https://storage.googleapis.com/cuhk-metaverse/public/assets/logo/cuhk_med.png',
    alt: 'CUHK Medicine',
    width: 100,
    height: 50,
  },
  {
    url: 'https://storage.googleapis.com/cuhk-metaverse/public/assets/logo/cusbs.png',
    alt: 'CUSBS',
    width: 44,
    height: 22,
  },
  {
    url: 'https://storage.googleapis.com/cuhk-metaverse/public/assets/logo/elite.png',
    alt: 'ELITE',
    width: 50,
    height: 25,
  },
  {
    url: 'https://storage.googleapis.com/cuhk-metaverse/public/assets/logo/scantheworld.png',
    alt: 'Scan the World',
    width: 50,
    height: 25,
  },
] as const;

/** Default fallback for missing user avatars, and the website's own
 * favicon/site-icon (see index.html) — Kelvin's asset, 2026-09-25. */
export const PLATFORM_MARK_URL =
  'https://storage.googleapis.com/cuhk-metaverse/public/assets/cuhk_med_logo_only.png';

/** Large standalone logo mark on light backgrounds (error page, unsubscribe
 * page) — transparent PNG, unlike PLATFORM_MARK_URL's solid-white-background
 * version made for cropping into small circular avatars. */
export const PLATFORM_MARK_TRANSPARENT_URL =
  'https://storage.googleapis.com/cuhk-metaverse/public/assets/CUHK_LOGO_TRANSPARENT_BG.png';
